import React from 'react'
import { PageHeader } from '@superhi/design'

import Intro from './components/Intro'
import Team from './components/Team'
import CompanyName from './components/CompanyName'
import WhyOnline from './components/WhyOnline'
import { Props } from './data'
import ROUTE from './route'

import { PageConfig } from 'src/routing/types'
import SEO from 'src/components/SEO'
import Contact from 'src/components/sections/Contact'
import Main from 'src/components/Main'
import Page from 'src/components/Page'

const About: PageConfig<Props> = ({ team }) => (
  <Page>
    <SEO
      title="About"
      description="SuperHi is an online education platform and worldwide community of creatives learning together. Our flexible online courses are designed for creatives and made for everyone."
    />

    <Main>
      <PageHeader title="About SuperHi" backgroundVersion="RED_01" />

      <Intro />

      {team && <Team {...team} />}

      <CompanyName />

      <WhyOnline />

      <Contact />
    </Main>
  </Page>
)

About.route = ROUTE

export { getStaticProps } from './data'
export default About
